import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(() => ({
  rangeDatePickerContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    maxWidth: 384,
  },
}));
